/**
 * DOM helpers. Centralised so we don't sprinkle querySelector calls and to
 * encourage data-attribute hooks instead of CSS class coupling.
 */

export const $ = (selector, root = document) => root.querySelector(selector);
export const $$ = (selector, root = document) =>
    Array.from(root.querySelectorAll(selector));

export const byHook = (hook, root = document) =>
    $(`[data-marc-${hook}]`, root);

export const allByHook = (hook, root = document) =>
    $$(`[data-marc-${hook}]`, root);

export const show = (el) => {
    if (!el) return;
    el.hidden = false;
};

export const hide = (el) => {
    if (!el) return;
    el.hidden = true;
};

export const toggle = (el, on) => {
    if (!el) return;
    el.hidden = !on;
};

export const setText = (el, text) => {
    if (!el) return;
    el.textContent = text;
};

export const setAttr = (el, attr, value) => {
    if (!el) return;
    if (value === null || value === undefined) {
        el.removeAttribute(attr);
    } else {
        el.setAttribute(attr, String(value));
    }
};

export const formatBytes = (bytes) => {
    if (!Number.isFinite(bytes)) return '';
    const units = ['B', 'KB', 'MB', 'GB'];
    let value = bytes;
    let i = 0;
    while (value >= 1024 && i < units.length - 1) {
        value /= 1024;
        i += 1;
    }
    return `${value.toFixed(value >= 10 || i === 0 ? 0 : 1)} ${units[i]}`;
};

export const escapeHtml = (str) =>
    String(str ?? '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
